/**
 * TURN CC · 22 (Design refresh) — Filter chips.
 *
 * Style: shadcn Badge-esque, `rounded-full`, `text-xs font-medium capitalize`.
 * Active = pleine couleur du type (bg + text-white). Inactive = outline
 * neutre avec léger dot coloré.
 * Persist inchangé (localStorage `hm_calendar_filters`).
 */
import { useEffect } from "react";
import { CALENDAR_ALL_TYPES } from "@/hooks/useCalendarEvents";
import { TYPE_META } from "./calendarMeta";

const LS_KEY = "hm_calendar_filters";

export function loadFilters() {
  try {
    const raw = localStorage.getItem(LS_KEY);
    if (!raw) return CALENDAR_ALL_TYPES;
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return CALENDAR_ALL_TYPES;
    const filtered = parsed.filter((t) => CALENDAR_ALL_TYPES.includes(t));
    return filtered.length > 0 ? filtered : CALENDAR_ALL_TYPES;
  } catch {
    return CALENDAR_ALL_TYPES;
  }
}

export default function CalendarFilters({ value, onChange }) {
  useEffect(() => {
    try { localStorage.setItem(LS_KEY, JSON.stringify(value)); } catch { /* ignore */ }
  }, [value]);

  const toggle = (type) => {
    if (value.includes(type)) {
      if (value.length === 1) return; // keep at least one
      onChange(value.filter((t) => t !== type));
    } else {
      onChange([...value, type]);
    }
  };

  return (
    <div className="flex items-center gap-1.5 flex-wrap" data-testid="calendar-filters">
      {CALENDAR_ALL_TYPES.map((type) => {
        const meta = TYPE_META[type];
        const Icon = meta.Icon;
        const active = value.includes(type);
        return (
          <button
            key={type}
            type="button"
            data-testid={`calendar-filter-${type}`}
            data-active={active}
            onClick={() => toggle(type)}
            className={
              "inline-flex items-center gap-1.5 rounded-full h-7 px-2.5 " +
              "text-[11px] font-medium capitalize transition-all border " +
              (active
                ? meta.chipActive + " shadow-sm"
                : "bg-transparent border-slate-200 dark:border-white/10 " +
                  "text-slate-500 dark:text-slate-400 opacity-70 " +
                  "hover:opacity-100 hover:border-slate-300 dark:hover:border-white/20 " +
                  "hover:text-slate-700 dark:hover:text-slate-200")
            }
          >
            {!active && (
              <span
                className="h-1.5 w-1.5 rounded-full shrink-0"
                style={{ background: meta.color, opacity: 0.7 }}
              />
            )}
            {Icon && <Icon className="h-3 w-3 shrink-0" />}
            {meta.label}
          </button>
        );
      })}
    </div>
  );
}
